module.exports = __webpack_public_path__ + "img/mgh-toyosu-bayside-cross-tokyo@2x.418c5d35.jpg";